import httpClient from "./httpClient";

const getShops = (page , pageSize) => httpClient.get(`/Shops?page=${page}&pageSize=${pageSize}`).then(
    (response) => {return response.data}
)

const  setShops = (params) => httpClient.post("/Shops",
  {
    name: params.name,
    file:params.file,
    categoryId: params.category,
    subCategoriesId: params.subCategories,
    floor: params.floor,
    plate: params.plate,
    location: params.location,
    phoneNo: params.phoneNo,
    mainImgPath: params.mainImgPath,
    instagram:params.instagram
  },{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const putShops = (params,id) => httpClient.put(`/Shops/${id}`, {
  id:id,
  name: params.name,
  file:params.file,
  categoryId: params.category,
  subCategoriesId: params.subCategories,
  floor: params.floor,
  plate: params.plate,
  location: params.location,
  phoneNo: params.phoneNo,
  mainImgPath: params.mainImgPath,
  instagram:params.instagram
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const deleteShops = (id) => httpClient.delete(`/Shops/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })



export {
  getShops ,
  setShops,
  putShops,
  deleteShops
}
